import { createContext } from 'react';

const CardListContext = createContext({ display: 'list', columns: 0 });

export default CardListContext;
